import * as React from 'react'
import styled from 'styled-components'
import {
  findIntakeWithIdQuery_findIntakeWithId,
  GetOwnIntakeQuery_getOwnIntake,
  ListContentsQuery_listContents,
} from '../../schema/schemaTypes'
import { replaceAssets } from '../../utils/replaceAssets'
// import {ReadButton} from '../../atoms/ReadButton'
import { isMobile } from 'react-device-detect'
interface IProps {
  content: ListContentsQuery_listContents
  intake: GetOwnIntakeQuery_getOwnIntake
  patientIntake: findIntakeWithIdQuery_findIntakeWithId
  screenNo?: string
}

export const ContentsView = ({ screenNo, content, intake, patientIntake }: IProps) => {
  const s = replaceAssets(content.content, intake, patientIntake)
  // const str = s.replace( /(<([^>]+)>)/ig, '')

  if(content.noPadding) {
    return (
      <>
          <ContentNoPadding
            id="myContent" dangerouslySetInnerHTML={{ __html: replaceAssets(content.content, intake, patientIntake) }} />
      </>
    )
  }
  return (
    <>
      <H1>{content.pageName}</H1>
      <Content dangerouslySetInnerHTML={{ __html: replaceAssets(content.content, intake, patientIntake) }} />
    </>
  )
}

const H1 = styled.h1`
`

const Content = styled.div`
  padding-bottom: 60px;
`

const ContentNoPadding = styled.div`
  width: 100%;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
`



// WEBPACK FOOTER //
// ./src/organisms/Contents/ContentsView.tsx